import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomDeleteButtonProps {
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
}

const CustomDeleteButton = ({
  onClick,
  className,
  ariaLabel = "Delete",
}: CustomDeleteButtonProps) => {
  return (
    <button
      type="button"
      className={classNames(styles.deleteBtn, className)}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <Icons.Trash className={styles.trashIcon} />
    </button>
  );
};

export default CustomDeleteButton;
